import {
  Backdrop,
  createStyles,
  Popper,
  Portal,
  withStyles,
} from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import ResizeObserver from 'resize-observer-polyfill'
import styled from '../../../theme'
import { rotatedArrowGenerator } from '../../../utils/arrowGenerator'
import DateRangePickerWrapper from './DatePickerWrapper'

const styles = createStyles({
  arrow: {
    background: '#fff',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.25)',
    fontSize: 6,
    height: '20px',
    position: 'absolute',
    width: '20px',
    willChange: 'transform',
  },
  popper: rotatedArrowGenerator('#fff', true),
})

const ArrowCover = styled.div`
  min-height: 330px;
  min-width: 400px;
  background: #fff;
  position: relative;
  z-index: 2;
`

const DatePickerPopper: React.FunctionComponent<any> = ({
                                                          children,
                                                          classes,
                                                          anchorEl,
                                                          open,
                                                          onClose,
                                                          styles,
                                                          arrowRef = anchorEl,
                                                          placement = 'bottom-start',
                                                        }) => {
  const [arrowElement, setArrowElement] = useState(null)
  const [wrapperElement, setWrapperElement] = useState(null)
  const popperRef = useRef(null)

  React.useEffect(() => {
    document.addEventListener('touchmove', onClose)
    window.addEventListener('resize', onClose)
    document.addEventListener('scroll', onClose)
    // document.addEventListener('wheel', console.log)
    document.addEventListener('keydown', onClose)
    return () => {
      document.removeEventListener('touchmove', onClose)
      window.removeEventListener('resize', onClose)
      document.removeEventListener('scroll', onClose)
      // document.removeEventListener('wheel', onClose)
      document.removeEventListener('keydown', onClose)
    }
  }, [onClose])

  useEffect(() => {
    if (wrapperElement) {
      const ro = new ResizeObserver(() => {
        if (popperRef.current !== null) {
          popperRef.current.scheduleUpdate()
        }
      })

      ro.observe(wrapperElement)
      return () => {
        ro.disconnect()
      }
    }
  }, [wrapperElement, popperRef])

  const arrow = (data, options) => {
    const arrowElement = options.element

    const elBB = arrowRef.getBoundingClientRect()
    const arrowOffset = Math.min(
      elBB.left + elBB.width / 2 - 9,
      data.offsets.popper.width + data.offsets.popper.left - 51,
    )

    const placement = data.placement.split('-')[0]
    const isVertical = ['left', 'right'].indexOf(placement) !== -1

    const sideCapitalized = isVertical ? 'Top' : 'Left'
    const side = sideCapitalized.toLowerCase()
    const altSide = isVertical ? 'left' : 'top'
    data.arrowElement = arrowElement
    data.offsets.arrow = {
      [altSide]: '',
      [side]: arrowOffset - data.offsets.popper.left,
    }

    return data
  }

  return (
    <>
      <Portal>
        <Backdrop
          open={open}
          onClick={onClose}
          style={{ zIndex: 5000, ...styles }}
          invisible={true}
          timeout={0}
        />
      </Portal>
      {anchorEl && open && (
        <Popper
          anchorEl={anchorEl}
          open={open}
          placement={placement}
          className={classes.popper}
          modifiers={{
            arrow: {
              element: arrowElement,
              enabled: true,
              fn: arrow,
            },
            flip: {
              enabled: true,
            },
            preventOverflow: {
              boundariesElement: 'viewport',
              enabled: true,
            },
          }}
          style={styles}
          popperRef={popperRef}
        >
          <>
            <div ref={setArrowElement} className={classes.arrow}/>
            <DateRangePickerWrapper ref={setWrapperElement}>
              <ArrowCover>{children}</ArrowCover>
            </DateRangePickerWrapper>
          </>
        </Popper>
      )}
    </>
  )
}

export default withStyles(styles)(DatePickerPopper)
